import * as HttpService from './http.service';
import * as URL from './url.service';

export const createIndexHistoriesUrl = (data) => HttpService.postWithAuth(URL.CREATE_INDEX_HISTORY_URL, data);
export const getServerTime = (data) => HttpService.getWithOutAuth(URL.GET_SERVER_TIME, data);
export const createIndexSecurities = (data) => HttpService.postWithAuth(URL.CREATE_INDEX_SECURITY_URL, data);
export const createIndexLives = (data) => HttpService.postWithAuth(URL.CREATE_INDEX_LIVE_URL, data);
export const getIndexHistories = (token, data) => HttpService.getWithAuth(URL.GET_INDEX_HISTORIES(data.indexId), token);
export const getHsIndexHistories = (token, data) => HttpService.getWithAuth(URL.GET_HS_BOND_INDEX_HISTORIES(data), token);
export const getBasisIndexHistories = (token, data) => HttpService.getWithAuth(URL.GET_BASIS_BOND_INDEX_HISTORIES(data), token);
